
  export default {
    name: 'SuggestionCardProductCategory',

    props: {
      data: {
        type: Object,
        default: () => {},
      },
      comboCardProductId: {
        type: String,
        default: "",
      },
      comboId: {
        type: String,
        default: "",
      },
      isMobile: String,
      clearTooltip:{
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        settings: {
          arrows: true,
          dots: true,
          adaptiveHeight: true,
          autoplay: true,
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                  arrows: false,
              },
            },
          ]
        },
        
        showTooltips: {}

      }
    },
        
    beforeMount() {
        this.addClearTooltipEventHandler();
    },

    beforeDestroy() {
        this.removeClearTooltipEventHandler();
    },
        
    methods: {
        addClearTooltipEventHandler() {
            window.addEventListener(
                'scroll',
                this.$_.debounce(this.handleClearTooltip, 150)
            );
        },
        removeClearTooltipEventHandler() {
            window.removeEventListener('scroll', this.handleClearTooltip);
        },
        handleClearTooltip() {
            this.showTooltips = {}
        },

        enableTooltip(id) {
            this.$set(this.showTooltips, id, true)
        }
    },

    watch: {
        clearTooltip(newBoo, oldBoo) {
            if (newBoo > oldBoo && newBoo > 0) {
                this.handleClearTooltip()
            }
        }
    },

  }
